export default {
  custom: {
    batchModify: 'Bulk Editing',
    importResumeanalysis: 'Import resume parsing',
    exportList: 'The export list',
    exportAllFields: 'Export all fields',
    webfromlink: 'A link for a WEB form',
    transfer: 'Transfer',
    receive: 'Receive',
    distribution: 'Distribution',
    move: 'Move',
    modify: 'Modification',
    returnToHighSeas: 'Return to high seas pool',
    returnToHighSeasSuccess: 'Returned to high seas pool',
    receiveSuccess: 'receive successful',
    share: 'Share',
    nextStep: 'Next step',
    linkPublish: 'Links to release',
    technicalSupport: 'Digital Integrated Management Platform',
    dataDetails: 'Details of the data',
    basicData: 'Basic information',
    open: 'Open',
    copy: 'Copy',
    openAccess: 'Open access',
    accessWithPwd: 'Access with password',
    scanQRcodeForFriend: 'Scan the QR code and share it with your friends',
    SigninQRcode: 'Sign in QR code',
    downloadQRcode: 'Download QR code',
    extendedLinks: 'Extended links',
    multipleLinkMsg:
      'Assign multiple link addresses to the same form to identify different data submission sources',
    copyToClipboard: 'Copied to clipboard',
    signin: 'Sign in',
    addSubmenu: 'Add submenu',
    checkShowFields: 'Check the fields you want to display',
    batchupdateMsg1:
      'Data batch modification will not be allowed to withdraw, do not support the search field batch modification',
    batchupdateMsg2:
      'Do not support batch modification components include: attachments, pictures, simple formulas, function formulas, advanced formulas, automatic numbering, association, bar code, location, rich text',
    fieldsToModify: 'Fields to modify',
    modifiedValue: 'The modified value is',
    modifiedValueNotEmpty: 'The modified value cannot be null',
    emailFormatError: 'Email format error',
    phoneFormatError: 'Mobile phone format error',
    enterInteget: 'Please enter an integer',
    numComponentMaxlength9: 'The maximum length of the digital component is 9 digits',
    decimalNumber: 'The decimal place is at most',
    batchupdataSuccess: 'Batch modification completed',
    batchupdataLongMsg:
      'If the processing time is too long, you can deal with other work first, and the system will continue to process the remaining data.',
    selectMatchingRule: 'Please select the match rule',
    diyNeeds: 'individual needs',
    writeLetters: 'Write a letter ',
    dynamic: 'Dynamic condition',
    transferPerson: 'Transfer person',
    transformation: 'Transition',
    dataLink: 'Data Link',
    matching: 'Matching ',
    datalinkNotopen: 'Data link not open',
    automationTuijian: 'Automation recommendation',
    uploadPictures: 'Upload pictures',
    addAttachments: 'Add attachment',
    useAppScan: 'Using the Mobile APP to scan access data',
    noPermission: 'No permission',
    name: 'Name',
    screenConditions: 'Screening condition',
    visibleMembers: 'Visible member',
    submenuNameRequired: 'Submenu name required',
    hideOlderDynamics: 'Hide earlier dynamics',
    haveChecked: 'Have already checked',
    noLook: 'Did not see',
    operator: 'Operator',
    operationTime: 'Operation time',
    comment: 'Communication',
    lookState: 'Check the status',
    unknownNameData: 'Data of unknown names',
    batchImportResumeanalysis: 'Batch import resume parsing',
    selectResumeFile: 'Please select the resume file to import',
    clickUploadMulitpResumeFile:
      'Multiple resumes can be uploaded by clicking, up to 10 at a time, no more than 10MB for a single file',
    addFile: 'Add file',
    supportDoc: 'Supports doc, docx, PDF, HTML, JPG, BMP and other formats',
    analyticalResults: 'Analysis result',
    analyticalComplete: 'The parse is successful',
    analyticalFail: 'Parsing failed. Please check whether the network is normal',
    dataOutLink: 'Data chain',
    dataInLink: 'Data Link (Internal Use Only) ',
    onlyUseAppSaoyisao: 'Please use Mobile APP to scan QR code to access',
    dataSharingSettings:
      'Specifies the data sharing Settings that allow departments or members to share this data together',
    shareTo: 'Shared with',
    accessAuth: 'Access authority',
    onlyReady: 'Read only',
    readyEdit: 'Read-write',
    readyEditDelete: 'Read and write delete',
    modulePrintPdf: 'Print the module details page (PDF format)',
    printPreview: 'Print preview',
    printSetting: 'Print setup',
    downloadTemplate: 'Download the template',
    importTemplate: 'Import the template',
    complete: 'Accomplish',
    importData: 'Import data',
    updateData: 'Update check-in status',
    pleaseImportData: 'Prepare the data to be imported in the format of the data template',
    mattersNeedingAttention: 'Matters need attention',
    updateDataBeCareful1: 'Import templates can be created on your own and must be in XLS format',
    updateDataBeCareful2:
      'The first action list field of the template should contain the name of the matching field and the check-in status.The names must be the same',
    updateDataBeCareful3:
      'It is best to choose the field without duplicate data. If multiple data are matched during the update import, the latest data will be taken as the update content',
    updateDataBeCareful4: 'An update import can only make changes to existing data',
    importDataBeCareful1:
      'The header name in the template cannot be changed, and the header line cannot be deleted',
    importDataBeCareful2:
      'The import format is XLSX, with a maximum of 10000 uploads and a maximum file size of 20M',
    importDataBeCareful3:
      'Radio type: the system provides the radio value corresponding to the field, the user can only choose, can not enter manually, otherwise an error will be reported',
    importDataBeCareful4:
      'Multiple selection type: field remarks provide the corresponding option value of the field, users need to enter the option value, if there are more than one option value, please use English "," separated',
    importDataBeCareful5: 'Date/time format: 2018-2-23, 2018-8-23 12:00:00',
    importDataBeCareful6:
      'Multi-stage drop-down: users need to input multi-stage drop-down option value by themselves, and the option value is separated by English ","',
    importDataBeCareful7:
      'Subform: the contents of the subform are displayed in the new sheet page, and the subform number corresponds to the serial number of the main table',
    clickDownloadTemplate: 'Click here to download the data import template',
    chooseTemplate: 'Select the data template that you want to import',
    dataTemplateMax10000:
      'In the data template, the name of the header field should be consistent with that of the system, and the number of imported rows should not exceed 10000. Please import in batches if the number exceeds 10000',
    chooseMatchingData: 'Select the field to update after matching the data',
    chooseDataField: 'Select the matching field for the data',
    addComplete: 'Add successful',
    importError1: 'Import data failed, please download failure log',
    importError2: 'Click here to download the import failure log',
    importError3: 'Import data failed',
    chooseMatchField: 'Select the matching field for the data',
    chooseUpdateloadTemplate: 'Please upload the template file',
    startImport: 'Start importing',
    return: 'Return',
    moveTo: 'Moving to',
    moveComplete: 'Move success',
    closeAll: 'Close all',
    closeOther: 'closes the other',
    refreshCurrentPage: 'Refresh current page',
    Correlation: 'Association',
    serialNumber: 'NO.',
    autoCreate: 'Automatic generation',
    checkRepeat: 'Duplicate checking',
    checkInStatus: 'Sign in state',
    selectProvince: 'Select provincial area',
    unknown: 'Unknown',
    saveAutoCreate: 'Save and generate automatically',
    saveAutoCompute: 'Save and calculate automatically',
    national: 'Nationwide',
    uploadResume: 'Upload resume',
    oneFileMax10M: 'A single file must not exceed 10MB',
    supportDocDocx: 'Supports doc, docx, PDF, HTML, JPG, BMP and other formats',
    analysisFailCheckNetwork: 'Parsing failed. Please check whether the network is normal',
    addRecords: 'Append record',
    uploadAvatar: 'Upload photo as avatar',
    gray: 'Gray level',
    blackWhite: 'Black and white',
    inverse: 'Inverse',
    attPicNotFirst: "Don't put attachments and pictures first",
    subformNotFirst: 'Subforms cannot be first',
    zhangsan: 'Zhang San',
    proviewMode: 'Preview mode',
    transTargetModule: 'Convertible target module',
    noTransModule: 'No conversion module',
    transSuccess: 'Conversion success',
    ifTransDataInfo:
      'Transfer the current owner of the data to another owner?Once the transfer is successful, the operation cannot be resumed',
    transShareMember: 'Transfer and share to the current data owner',
    personNotEmpty: 'The person in charge cannot be empty',
    sharepersonNotEmpty: 'The sharer cannot be null',
    fenpeiSuccess: 'Distribution of success',
    selectReturnHighpool: 'Select the high seas pool to return to',
    selectMoveHighpool: 'Select the high seas pool to move to',
    personnelCard: 'Personal business card',
    editModuleLayout: 'Module Settings',
    modifyIconName: 'Modify icon and name',
    manageCockpit: 'Data report',
    total: 'Total',
    determineDelReport: 'Are you sure you want to delete the data analysis?',
    realNameAuthMsg:
      'When the real name is authenticated, the name / ID card number can not be empty.',
    idCardBad: 'The ID number is not correct.',
    verificationPassed: 'Verification passed',
    verificationFailed: 'Verification failed',
    continueSaving: 'Continue saving',
    doNotSave: 'Do not save',
    sendEmail: 'Send mail',
    record: 'Records',
    showNotFilledField: 'Displays unfilled fields',
    hiddenNotFilledField: 'Hide the unfilled fields',
    idCradPicture1: 'Face photograph',
    idCradPicture2: 'A photograph of the national emblem',
    // 新增：行驶证上传说明
    idCradPicture3: 'Vehicle License Image',
    freezeThisColumn: 'Frozen column',
    unfreezeThisColumn: 'Thaw this column',
    uploadOnly: 'Upload only allowed',
    limitPerPicture: 'Limit per picture',
    limitPerAttachment: 'Limit per attachment',
    manageSubmenu: 'Manage submenu',
    hierarchyView: 'Hierarchy view',
    timeAxisView: 'Timeline view',
    moduleSubmenuInfo1: 'Drag to adjust the display position of the submenu',
    moduleSubmenuInfo2:
      'Select a field of option type, and the data is displayed in kanban grouped by the option values in this field.Support components: drop-down options (radio), check boxes (radio)',
    moduleSubmenuInfo3:
      'Select a field with an association, and the data will be hierarchically displayed in tree shapes from left to right at the parent-child level in that field.Supporting components: associative relationships (associating their own modules, such as customer module associative customer module)',
    moduleSubmenuInfo4: 'The data content is presented in chronological order',
    viewName: 'The name of the view',
    timelineField: 'Timeline field',
    sortOrder: 'Sortord',
    selectGroupField: 'Select group fields',
    formNotEligibleField: 'There are no qualifying fields in the current form',
    fieldsGroup: 'Field group',
    cardAppearance: 'The CARDS look',
    moreAdd8Field: 'Limit the addition of eight fields',
    showFieldName: 'Display field name',
    showField: 'Display field',
    pleaseSelectGroupField: 'Please select the grouping field',
    onlyOneSelectField: 'Please select at least one display field',
    startString: 'Beginning character',
    kanban: 'Board',
    hierarchy: 'Hierarchy',
    timeLine: 'Timer shaft',
    allDynamic: 'All dynamic',
    onlyDynamic: 'Only comment',
    onlyViewStatus: 'View status only',
    onlyOperationLog: 'Operating log only',
    showOlder: 'Show earlier',
    groupFieldDel: 'The grouping field has been deleted. Please edit the submenu',
    notSpecified: 'Not specified',
    adaptToScreen: 'To adapt to the screen',
    unknownTime: 'The unknown time',
    addDataToSeas:
      'Through this link, data can be automatically established in the high seas pool and different data submission sources can be identified',
    cashier: 'Cashier desk',
    paymentCompleted: 'Payment completed',
    choosePaymentMethod: 'Choose payment method',
    successfulCollection: 'Successful collection',
    paymentByCanning: 'Payment by scanning (yuan)',
    openMobileWechat: 'Open mobile wechat',
    openMobileAlipay: 'Open alipay mobile phone',
    scanToCompletePayment: 'Scan completes the payment',
    manageApplication: 'Application management',
    applicationDescription: 'Application description',
    enterpriseInfo: 'Enterprise information',
    riskInfo: 'Risk information',
    transferOtherrelatedModules: 'Transfer other related modules',
    uploadMore10Files: 'Up to 10 files can be uploaded at a time',
    onlyNewCreate: 'New only',
    companyInfo1: 'Friendly prompt: Please input the correct name',
    companyInfo2: 'Querying',
    companyInfo3: 'Legal person',
    companyInfo4: 'Business status',
    notSetAppInfo: 'Application description not set',
    paid: 'Paid',
    toBePaid: 'To be paid',
    orderPayment: 'Order payment',
    autoCount: 'Automatic calculation',
    payCallbackInfo: 'When the amount is > 0, you can click to collect',
    detailData: 'Details',

    // 2020-12-25国际化
    shareOtherModule: 'Share other related modules',
    subformBatchupdateMsg1: 'Batch modification of data in sub forms is not supported',
    subformBatchupdateMsg2:
      'Attachment, picture, simple formula, function formula, advanced formula, quotation formula, automatic numbering, serial number, bar code, handwritten signature, resume analysis',
    CopyLine: 'Copy the line',
    OnlineConsulting: 'Online consultation',
    NameFfTrialCompany: 'Name of trial organization',

    // 2021-04-12
    selectOneColumn: 'Select at least one field as the export column',
    selectExportFields:
      'Select the field you want to export (checked to export the value of the field)',
    companyDataKanban: 'Organization marketing data kanban',
    personalDataKanban: 'Personal marketing data kanban',
    visitorsToAnalysis: 'Visitors to analysis',
    newAddSevendays: 'New visits in the past seven days',
    accessTotalNum: 'Access to the total number of',
    NewDayAdd: 'New day',
    shareTotalNum: 'The total number of share',
    accessData: 'To access the data',
    AllTotal: 'The accumulative total',
    yesterday: 'Yesterday',
    nearly7days: 'Nearly 7 days',
    nearly30days: 'Nearly 30 days',
    visitorsInterested: 'Visitors interested in',
    visitorActivity: 'Visitor activity',
    VisitorProduct: 'Visitor product Interaction',
    AccessToheTotal: 'Access to the total',
    BusinessCardLook: 'Business card to view',
    BusinessCardShare: 'Business card share',
    BusinessCardCollection: 'Business card collection',
    productLook: 'View the product',
    productShare: 'Product to share',
    product: 'Product',
    videos: 'Video',
    shareBusinessCard: 'Share business card',
    AccessToInterest: 'Access to interest',
    AccessToSource: 'Access to the source',
    InteractiveRecord: 'Interactive record',
    AIAnalysis: 'AI analysis',
    allTheRecords: 'All the records',
    transToBussData: 'Conversion to business data',
    sureTransBussData: 'Are you sure you want to convert to business data?',
    batchDownload: 'All download',

    // 2022-04-12
    InsertRowsAbove: 'Insert rows above',
    InsertRowsBelow: 'Insert rows below',
    DataSharingSettings: 'Data sharing settings',
    MapMode: 'Map mode',
    selectPagesExportNum: 'Select the number of pages to export',
    amount: 'Amount',
    relatedContent: 'Related content',
    searchModule: 'Search module',
    largeAmountData: 'Too much data',
    largeAmountDataInfo:
      'Please "filter" the data in the column field and display the list data after filtering'
  }
}
